import { createFileRoute } from "@tanstack/react-router";
import { Icon } from "@iconify/react";
import { Spinner, Table } from "@heroui/react";

import { ButtonLink } from "@/features/ui/button.ts";
import {
  TariffConfigurationEntity,
  useTariffsConfigurations,
} from "@/features/tariffs-configurations/use-tariffs-configurations.ts";
import { DeleteTariffsConfigurationsModal } from "@/features/tariffs-configurations/ui/delete-tariffs-configurations-modal.tsx";

export const Route = createFileRoute("/dashboard/tariff/configuration/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { data, isPending } = useTariffsConfigurations();

  return (
    <div className="flex flex-col pt-4 pr-4">
      <div className="flex flex-row gap-2 justify-between h-12 items-center">
        <p className="font-bold text-xl">Базовые цены</p>

        <ButtonLink
          to="/dashboard/tariff/configuration/add"
          variant="primary"
        >
          Создать
          <Icon className="size-6" icon="solar:add-circle-bold" />
        </ButtonLink>
      </div>

      {isPending ? (
        <div className="flex justify-center py-8">
          <Spinner />
        </div>
      ) : (
        <Table.Root className="mt-8">
          <Table.Content aria-label="Базовые цены">
            <Table.Header>
              <Table.Column>Название</Table.Column>
              <Table.Column>
                <p className="text-wrap w-44">
                  Себестоимость одного выезда курьера
                </p>
              </Table.Column>
              <Table.Column>
                <p className="text-wrap w-44">Себестоимость топлива на 1 заказ</p>
              </Table.Column>
              <Table.Column>
                <p className="text-wrap">Итоговая амортизация на заказ</p>
              </Table.Column>
              <Table.Column>
                <p className="text-wrap">Налог в %</p>
              </Table.Column>
              <Table.Column>
                <p className="text-wrap">Комиссия банка в %</p>
              </Table.Column>
              <Table.Column>
                <p className="text-wrap">Плановая наценка в %</p>
              </Table.Column>
              <Table.Column> </Table.Column>
            </Table.Header>
            <Table.Body items={data?.data ?? []}>
              {(configurationsId: TariffConfigurationEntity) => (
                <Table.Row id={String(configurationsId.id)}>
                  <Table.Cell>{configurationsId.title}</Table.Cell>
                  <Table.Cell>{configurationsId.costOfOneCourierVisit}</Table.Cell>
                  <Table.Cell>{configurationsId.fuelCostPerOrder}</Table.Cell>
                  <Table.Cell>
                    {configurationsId.totalDepreciationPerOrder}
                  </Table.Cell>
                  <Table.Cell>{configurationsId.tax}</Table.Cell>
                  <Table.Cell>{configurationsId.bankCommission}</Table.Cell>
                  <Table.Cell>{configurationsId.plannedMarkup}</Table.Cell>
                  <Table.Cell>
                    <div className="flex flex-row gap-2 justify-end">
                      <ButtonLink
                        isIconOnly
                        params={{
                          configurationId: configurationsId.id.toString(),
                        }}
                        to="/dashboard/tariff/configuration/$configurationId/edit"
                        variant="ghost"
                      >
                        <Icon className="size-6" icon="solar:pen-bold-duotone" />
                      </ButtonLink>

                      <DeleteTariffsConfigurationsModal
                        configurationsId={configurationsId.id}
                      />
                    </div>
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table.Content>
        </Table.Root>
      )}
    </div>
  );
}
